import React from 'react'
import Checkbox from '../../components/Checkbox'
export default () => (
  <Checkbox />
)